import React from 'react';

const LogisticsBanner = () => {
  return (
    <div className="about-banner logistics-banner">
      <div className="container">
        <div className="banner-heading">
          <h1>Logistics Process</h1>
          <div className="divider-shape"></div>
        </div>
      </div>
    </div>
  );
};

export default LogisticsBanner;
